import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { OnDemandPickupAddress } from 'src/app/core/models/operations/on-demand-pickup-address.model';
import { OnDemandPickup } from 'src/app/core/models/operations/operations-on-demand-pickup.model';
import { PICKUP_ADDRESS_CONSTANTS } from '../current-pickup-section/current-pickup-section.constants';
import { CONSTANTS } from './address-section.constants';

@Component({
  selector: 'app-address-section',
  templateUrl: './address-section.component.html',
  styleUrls: ['./address-section.component.scss'],
  standalone: false,
})
export class AddressSectionComponent {
  @Input() data!: OnDemandPickupAddress;
  @Input() form!: FormGroup;
  @Input() events!: Observable<void>;
  @Input() uncheckEvent!: Observable<void>;
  @Output() formUpdateEvent = new EventEmitter<OnDemandPickup>();

  readonly HEADER = CONSTANTS;
  readonly CONSTS = PICKUP_ADDRESS_CONSTANTS;
}
